import { useIntl } from "@components/Intl"
import React, { FC, InputHTMLAttributes } from "react"
import * as S from "./elements"

type SearchInputProps = InputHTMLAttributes<HTMLInputElement> & {}

const SearchInput: FC<SearchInputProps> = (props) => {
  const { locale } = useIntl()

  return (
    <S.Container>
      <S.Icon />
      <S.Input
        {...props}
        placeholder={
          locale === "nl"
            ? "Waar bent u naar op zoek?"
            : "What are you looking for?"
        }
        autoFocus
      />
    </S.Container>
  )
}

export default SearchInput
